import { toast } from "react-toastify";

import { mutate } from "swr";
import CatchErr from "../lib/CatchErr";
import HttpInterceptor from "../lib/HttpInterceptor";


const Logout = async (navigate,setSession) => {
  // Always redirect to landing page after logout (including in PWA).
  // Using a hard redirect avoids Guard/401 redirects racing us back to /login.
  const postLogoutPath = '/';

  try {

    await HttpInterceptor.post("/auth/logout");

    setSession(null)
    mutate(() => true, undefined, { revalidate: false }); //  Clear SWR cache globally
    
    // Clear any client-side storage
    localStorage.clear();
    // Set flag to prevent back navigation to login with cached password
    // This flag will be checked by Login component to clear form state
    sessionStorage.setItem('just-logged-out', 'true');
    // Clear sessionStorage after setting flag (but keep the flag briefly)
    // Actually, we need to keep the flag so Login can detect it
    // sessionStorage.clear(); // Don't clear - we need the flag

    toast.success("Logout Successful");
    if (typeof window !== 'undefined' && typeof window.location?.replace === 'function') {
      // Use replace to remove login page from history
      window.location.replace(postLogoutPath);
    } else {
      navigate(postLogoutPath, { replace: true });
    }
  } 
  catch (error) {
    CatchErr(error)
    // Even if logout fails, clear session and go to landing page
    setSession(null);
    mutate(() => true, undefined, { revalidate: false });
    localStorage.clear();
    // Set flag to prevent back navigation to login with cached password
    sessionStorage.setItem('just-logged-out', 'true');
    if (typeof window !== 'undefined' && typeof window.location?.replace === 'function') {
      window.location.replace(postLogoutPath);
    } else {
      navigate(postLogoutPath, { replace: true });
    }
  }
};

export default Logout;